module.exports = __webpack_public_path__ + "img/EXODONCIA_REALIZADA.png";